var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h2", [_vm._v("Comments:")]),
      _vm._v(" "),
      _vm._l(_vm.list, function(comment) {
        return _c(
          "div",
          { staticClass: "comment" },
          [
            _c("span", { staticClass: "author" }, [
              _vm._v(_vm._s(comment.author) + ":")
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: comment.can_delete,
                    expression: "comment.can_delete"
                  }
                ],
                staticClass: "delete-button",
                on: {
                  click: function($event) {
                    return _vm.del(comment.id)
                  }
                }
              },
              [_vm._v("✕")]
            ),
            _vm._v(" "),
            _c("vue-markdown", {
              attrs: {
                source: comment.text,
                html: false,
                linkify: false,
                anchorAttributes: { target: "_blank", rel: "nofollow" },
                postrender: _vm.cl
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "date" }, [
              _vm._v(_vm._s(comment.created))
            ])
          ],
          1
        )
      }),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: "comment-form",
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.submit($event)
            }
          }
        },
        [
          _c("input", {
            attrs: { type: "hidden", name: "entity_name" },
            domProps: { value: _vm.entity_name }
          }),
          _vm._v(" "),
          _c("input", {
            attrs: { type: "hidden", name: "entity_id" },
            domProps: { value: _vm.entity_id }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.text,
                    expression: "text"
                  }
                ],
                staticClass: "form-control",
                attrs: {
                  name: "text",
                  placeholder: "use Markdown",
                  required: ""
                },
                domProps: { value: _vm.text },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.text = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "error" }, [
                _vm._v(_vm._s(_vm.errors.text))
              ]),
              _vm._v(" "),
              _c("vue-markdown", {
                attrs: {
                  source: _vm.text,
                  html: false,
                  linkify: false,
                  anchorAttributes: { target: "_blank", rel: "nofollow" },
                  postrender: _vm.cl
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "row form-group" }, [
            _c("div", { staticClass: "col-6" }, [
              _c("input", {
                staticClass: "form-control",
                attrs: {
                  type: "text",
                  name: "author",
                  placeholder: "your name",
                  required: ""
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "error" }, [
                _vm._v(_vm._s(_vm.errors.author))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-6" }, [
              _c("input", {
                staticClass: "form-control",
                attrs: { type: "submit", disabled: _vm.loading }
              })
            ])
          ])
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }